// extracted by mini-css-extract-plugin
export default {"info":"Information_info__a7zKD"};